import CreamyTexture from 'components/utils/icons/CreamyTexture';
import NaturalFinish from 'components/utils/icons/NaturalFinish';
import OvalOral from 'components/utils/icons/OvalOral';
import { fireABTestGoal } from 'helpers/analyticsHelpers';
import { triggerCartEvent } from 'helpers/dataLayerHelpers';
import React, {
	useEffect, useState
} from 'react';

import {
	DesktopFlex,
	IconWrapper,
	InnerContainer,
	InnerWrapper,
	KitImage,
	KitWrapper,
	LineItem,
	PriceTag,
	ProductInfoWrapper,
	TextFlex,
	TitleWrapper,
	Triangle,
	UpsideDownTriangle,
} from './styles';

const CheckoutKit = ({
	products,
	setKitModalOpen,
	removeProduct,
	cart,
	setRXKit,
	bundlePrice,
	bundleDiscountPrice,
	clientToken,
	patientId,
	consultationId,
}) => {
	let screen = {};

	// Separate out Screen
	let sortedProducts = products.filter((product) => {
		if (product.medication_type === 'sunscreen') {
			screen = product;
		} else {
			return product;
		}
	});

	// Check to see if all
	sortedProducts.forEach(product => {
		if (!cart.products[product.id]) {
			return(null);
		}
	});

	useEffect(() => {
		sortedProducts && sortedProducts.forEach(product => {
			if (!cart.products[product.id]) {
				setRXKit(false);
			}
		});
	},
	[])

	async function handleRemoveProduct(remove) {
		removeProduct(screen.otc_id);
		// Handle GA4 event push for either a removal or an add
		triggerCartEvent(screen,
			remove);
	}

	async function handleOpenModal() {
		setKitModalOpen(true);
		await fireABTestGoal({
			csrfToken: clientToken,
			campaignName: 'checkout_rx_kit',
			goal: 'launched_edit_modal',
			patientId,
			consultationId,
			goalOrOther: 'goals',
		});
	}

	function displayItemPrice(item) {
		if (item.options && item.options[0] && item.options[0].price_cents) {
			return String(parseInt(item.options[0].price_cents / 100,
				10));
		}
		console.error('Missing item price',
			item);
		return '';
	}

	return (
		<KitWrapper>
			<DesktopFlex>
				<KitImage >
					<PriceTag>
						<InnerWrapper>
              Save ${(bundlePrice - bundleDiscountPrice) / 100}
							<Triangle />
							<UpsideDownTriangle />
						</InnerWrapper>
					</PriceTag>
				</KitImage>
				<InnerContainer>
					<h2>RX Advanced Acne Kit <span>&nbsp;${bundleDiscountPrice / 100}<span className="light">&nbsp;(${bundlePrice / 100} value)</span></span></h2>
					<p className="sub-header">These medications work hand-in-hand to target breakouts and get you the best results.</p>
					<LineItem style={{ marginBottom: 10 }}>
						<TextFlex>
							<p className="bold">Kit includes:</p>
						</TextFlex>
					</LineItem>
					{sortedProducts.map(product => (
						<LineItem key={product.descriptor_short}>
							<IconWrapper>
								{product.medication_type === 'topical'
									? <CreamyTexture />
									: <OvalOral />
								}
							</IconWrapper>
							<TextFlex>
								<p className="bold">{product.descriptor}</p>
								{product.medication_type === 'topical'
									? <p className="light"><span>${displayItemPrice(product)}</span> - Size: {!product.descriptor.includes('Body') ? '21g' : '45g'} (3 month supply)</p>
									: <p className="light"><span>${displayItemPrice(product)}</span> - Size: {product.options[0] && product.options[0].quantity} {product.medication_form} (3 month supply)</p>
								}
								<p>{product.marketing_description || 'A potent and effective medication for clearing acne.'}</p>
							</TextFlex>
						</LineItem>
					))}
					<LineItem>
						<IconWrapper natural>

						</IconWrapper>
						<TextFlex>
							<h5 onClick={handleOpenModal}>Edit kit</h5>
						</TextFlex>
					</LineItem>
				</InnerContainer>
			</DesktopFlex>
			{screen && cart.products[screen.otc_id] &&
        <>
        	<hr/>
        	<DesktopFlex screen>
        		<KitImage screen>
        			<PriceTag screen>
        				<InnerWrapper>
                  Everyday essential
        					<Triangle />
        					<UpsideDownTriangle />
        				</InnerWrapper>
        			</PriceTag>
        		</KitImage>
        		<ProductInfoWrapper>
        			<TitleWrapper>
        				<h3>{screen.descriptor}</h3>
        				<h4>$27</h4>
        			</TitleWrapper>
        			<h5>Size: 3.5 fl oz</h5>
        			<TitleWrapper>
        				<h5 onClick={() => handleRemoveProduct(true)}>Remove</h5>
        				<h6>Qty: 1</h6>
        			</TitleWrapper>
        		</ProductInfoWrapper>
        	</DesktopFlex>
        </>
			}
		</KitWrapper>
	);
};

export default CheckoutKit;
